import { Component, Input } from '@angular/core';
import { AbstractControl, AbstractControlDirective } from '@angular/forms';

import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-form-errors',
  template: `
    <ul class="list-unstyled form-errors" *ngIf="shouldShowErrors()">
      <li *ngFor="let error of listOfErrors()">{{ error }}</li>
    </ul>
  `,
})
export class FormErrorsComponent {
  constructor(private translateService: TranslateService) {}

  private readonly errorMessages = {
    required: (msg) => msg || this.translateService.instant('REQUIRED_FIELD'),
    email: (msg) => msg || this.translateService.instant('INVALID_EMAIL'),
    min: (msg) => msg || this.translateService.instant('INVALID_MINLENGTH'),
    max: (msg) => msg || this.translateService.instant('INVALID_MAXLENGTH'),
    minlength: (msg) => msg || this.translateService.instant('INVALID_MINLENGTH'),
    maxlength: (msg) => msg || this.translateService.instant('INVALID_MAXLENGTH'),
    pattern: (msg) => msg || this.translateService.instant('INVALID_CHARACTERS'),

    // custom validators
    invalid: (msg) => msg || this.translateService.instant('INVALID_FIELD'),
    fieldsMustMatch: (msg) => msg || this.translateService.instant('FIELDS_MUST_MATCH'),
    fieldAlreadyExists: (msg) => msg || this.translateService.instant('ALREADY_EXISTS'),
    fieldMask: (msg) => msg || this.translateService.instant('INVALID_ACCOUNT_MASK'), // TODO: freivin, this should be generic 'INVALID_MASK'
  };

  @Input() control: AbstractControlDirective | AbstractControl; // private -> Property 'control' is private and only accessible within class 'FormErrorsComponent'.
  @Input() messages; // private
  @Input() formSubmited = false; // private

  shouldShowErrors(): boolean {
    return this.control && this.control.errors && (this.control.touched || this.formSubmited);
    //this.control.dirty ||
  }

  listOfErrors(): string[] {
    return Object.keys(this.control.errors).map((field) => {
      let msg = '';

      if (this.messages && this.messages[field]) {
        msg = this.translateService.instant(this.messages[field]);
      }

      return this.getMessage(field, msg, this.control.errors[field]);
    });
  }

  private getMessage(type: string, msg: any, params: any) {
    return this.errorMessages[type](msg, params);
  }
}

/*private requiredMsg = 'REQUIRED_FIELD';
  private emailMsg = 'INVALID_EMAIL';
  private minlengthMsg = 'INVALID_MINLENGTH';
  private maxlengthMsg = 'INVALID_MAXLENGTH';
  private patternMsg = 'INVALID_CHARACTERS';
  private invalidPasswordMsg = 'INVALID_FORMAT_PASSWORD';
  private fieldsMustMatchMsg = 'FIELDS_MUST_MATCH';

  constructor(private translateService: TranslateService) {
    translateService.get(['']).subscribe((translations) => {
      this.requiredMsg = this.translateService.instant(this.requiredMsg);
      this.emailMsg = this.translateService.instant(this.emailMsg);
      this.minlengthMsg = this.translateService.instant(this.minlengthMsg);
      this.maxlengthMsg = this.translateService.instant(this.maxlengthMsg);
      this.patternMsg = this.translateService.instant(this.patternMsg);
      this.invalidPasswordMsg = this.translateService.instant(this.invalidPasswordMsg);
      this.fieldsMustMatchMsg = this.translateService.instant(this.fieldsMustMatchMsg);
    });
  }

  private readonly errorMessages = {
    required: (msg) => msg || this.requiredMsg,
    email: (msg) => msg || this.emailMsg,
    min: (msg) => msg || this.minlengthMsg,
    max: (msg) => msg || this.maxlengthMsg,
    minlength: (msg) => msg || this.minlengthMsg,
    maxlength: (msg) => msg || this.maxlengthMsg,
    pattern: (msg) => msg || this.patternMsg,
    // custom validators
    invalidPassword: (msg) => msg || this.invalidPasswordMsg,
    fieldsMustMatch: (msg) => msg || this.fieldsMustMatchMsg,
  };
  */

// msg = this.messages[field];

// this.translateService.get(msg).subscribe((newMsg) => {
//   msg = newMsg;
// });

// , params
// requiredLength
// requiredPattern

// private static readonly errorMessages = {
// , OnInit
// implements OnInit
// ngOnInit(): void {
//   console.log(this.messages);
// }
// return FormErrorsComponent.errorMessages[type](params);
